import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
import brandLogo from '../../assets/icons/Agilisium new logo .png';

function ContractsHubNavBar() {
  const [show, setShow] = useState(false);
  const [activeLink, setActiveLink] = useState('customer');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
     if (location.pathname === '/contractsHub/vendor') {
      setActiveLink('vendor');
    } else if (location.pathname === '/contractsHub/customer') {
      setActiveLink('customer');
  }
  }, [location]);

  const handleClose = (link) => {
    setShow(false);
    setActiveLink(link);
  };

  return (
    <>
      <Navbar
        expand="lg"
        className="bg-body-tertiary p-0"
        expanded={show}
        style={{ position: 'fixed', width: '100%', zIndex: '999' }}
      >
        <Container
          fluid
          style={{ background: '#FFF' }}
          className="bg-white p-1 border border-gray-400"
        >
          {/* Brand Logo */}
          <Navbar.Brand
            className="brand"
            onClick={() => {
              navigate('/contractsHub/customer');
              handleClose('customer');
            }}
          >
            <img
              src={brandLogo}
              alt="brand"
              style={{
                top: '19px',
                left: '48px',
                height: '58px',
                opacity: '1',
              }}
            />
          </Navbar.Brand>

          {/* Mobile Toggle */}
          <Navbar.Toggle
            aria-controls="contractsHubNavbarScroll"
            onClick={() => setShow(!show)}
          />

          {/* Navbar Links */}
          <Navbar.Collapse id="contractsHubNavbarScroll">
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              <Nav.Link
                as={NavLink}
                to="/contractsHub/customer"
                className={`px-4 navHeader ${activeLink === 'customer' ? 'active' : ''}`}
                onClick={() => handleClose('customer')}
              >
                Customer
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/contractsHub/vendor"
                className={`px-4 navHeader ${activeLink === 'vendor' ? 'active' : ''}`}
                onClick={() => handleClose('vendor')}
              >
                Vendor
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>

          {/* Button to Go Back */}
          <Navbar.Brand className="brand" onClick={() => navigate('/')}>
            <Button className="backtohomebtn">Go to Agilisium Page</Button>
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
}

export default ContractsHubNavBar;
